// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetTupperware from "../v3/Motion.res.mjs";
import * as StimulusTabContext$LiteracyplanetTupperware from "./StimulusTabContext.res.mjs";

function PilotStimulusTabContent(props) {
  var showing = Curry._1(StimulusTabContext$LiteracyplanetTupperware.useTabContent, props.tab);
  return React.createElement(Motion$LiteracyplanetTupperware.Div.make, {
              initial: {
                filter: "blur(10px)"
              },
              animate: {
                filter: "none"
              },
              className: showing ? "" : "hidden",
              children: Caml_option.some(props.children)
            });
}

var make = PilotStimulusTabContent;

var $$default = PilotStimulusTabContent;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
